<template>
    <ListItem
        :config="config"
        type="gallery"
    />
</template>
<script setup>
    import ListItem from '@/components/modules/ListItem.vue'

    const props = defineProps({
        config: Object,
    })
</script>
